import { render } from "./CommitmentCalendar.vue?vue&type=template&id=4ed05344"
import script from "./CommitmentCalendar.vue?vue&type=script&lang=js"
export * from "./CommitmentCalendar.vue?vue&type=script&lang=js"

import "./CommitmentCalendar.vue?vue&type=style&index=0&id=4ed05344&lang=scss"
script.render = render

export default script